import { track } from '../../lib/tracking';
import { navigationItem } from '../../tokens/navigationItem';
const navigationTrackEvents = {
    [navigationItem.logo]: 'Header_Header_Logo',
    [navigationItem.homepage]: 'Header_Home_Icon',
    [navigationItem.myaccount]: 'Header_Account_Menu',
    [navigationItem.cart]: 'Header_Cart',
};
export const trackNavigationEvents = (item, currentNavigationItem, recoveredCartItems = [], cartItemsCount = 0) => {
    if (item && currentNavigationItem !== item) {
        const recoveredItems = recoveredCartItems;
        if (navigationTrackEvents[item] === 'Header_Cart') {
            const stockStatusCounts = recoveredItems.reduce((accumulator, itemInRecoveredList) => {
                const { stockStatus } = itemInRecoveredList;
                accumulator[stockStatus] = accumulator[stockStatus]
                    ? accumulator[stockStatus] + 1
                    : 1;
                return accumulator;
            }, {});
            const trackingPayload = {
                addInfo: `active: ${cartItemsCount}, exp_available: ${stockStatusCounts.AVAILABLE || 0}, exp_reserved: ${stockStatusCounts.RESERVED || 0}, exp_soldOut: ${stockStatusCounts.SOLD_OUT || 0}`,
            };
            track(navigationTrackEvents[item], trackingPayload);
        }
        else {
            track(navigationTrackEvents[item]);
        }
    }
};
export const noopOnItemRemove = (_) => Promise.resolve();
export const noopOnItemClick = (_, __) => { };
export const noopOnCheckoutClick = () => { };
export const noopOnItemReserveAgain = (_) => Promise.resolve();
//# sourceMappingURL=helpers.js.map